(function () {
  class FreeSpinsMeter extends PIXI.Container {
    constructor() {
      super();

      this.freeSpinsAwarded = 0;
      this.currentFreeSpin = 0;

      this.totemExpanded = false;
    }

    //////////////////////////////////////////////////
    initialise() {
      //this.fsMeter = resourceManager.get( "freeSpinsMeter" );
      this.fsMeterText = resourceManager.get('freeSpinsMeter:freeSpinsPanelTextScaleContainer:freeSpinsPanelText');
    }

    //////////////////////////////////////////////////
    resetMeter() {
      //this.fsMeter.visible = true;

      this.freeSpinsAwarded = 0;
      this.currentFreeSpin = 0;

      //   this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
      this.fsMeterText.setText(this.freeSpinsAwarded);
    }

    //////////////////////////////////////////////////
    // hideMeter() {
    //     this.fsMeter.visible = false;
    // }

    //////////////////////////////////////////////////
    addSpins(numFs) {
      this.freeSpinsAwarded = this.freeSpinsAwarded + numFs;
      //   this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
      this.fsMeterText.setText(this.freeSpinsAwarded - this.currentFreeSpin);
    }

    //////////////////////////////////////////////////
    useSpin() {
      this.currentFreeSpin++;
      //   this.fsMeterText.setTranslationParameters(this.currentFreeSpin, this.freeSpinsAwarded);
      this.fsMeterText.setText(this.freeSpinsAwarded - this.currentFreeSpin);
    }

    //////////////////////////////////////////////////
    isLastFreeSpin() {
      return this.currentFreeSpin === this.freeSpinsAwarded;
    }

    isFirstFreeSpin() {
      return this.currentFreeSpin === 1;
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new FreeSpinsMeter();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {};

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return [''];
  };

  resourceManager.registerObjectType('freeSpinsMeter', create, initialise, getFilesRequired);
})();
